var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tableProvider',_vm._b({on:{"getData-table":function($event){return _vm.getDataDeposiit()},"clear-reload":_vm.clearReload}},'tableProvider',_vm.sentData,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }